<button (click)="onItemClicked()" class="ap-list-item__container">
    <ng-content></ng-content>
</button>
